export default __webpack_public_path__ + "static/media/slack-info.e7e46be0.svg";